export default {"src":"/_next/static/media/arrowUp.67e1d4e3.svg","height":9,"width":9,"blurWidth":0,"blurHeight":0};